import { Story } from '../../types/story';

export const marrakechRiad: Story = {
  id: 'marrakech-riad',
  title: 'Rooftop in the Medina',
  excerpt: 'A chance encounter in a Marrakech riad leads to a night where ancient walls hold modern secrets.',
  city: 'Marrakech',
  publishDate: '2025-12-16',
  readTime: '13 min read',
  tags: ['♀♂', 'rooftop', 'exotic', 'strangers'],
  categories: ['forbidden', 'adventurous'],
  intensity: 2,
  content: `The riad was hidden deep in the medina, down a narrow alley that smelled like mint and leather and something sweet I couldn't identify. I'd gotten lost three times trying to find it, following the blue pin on my phone through a maze of identical passages.

When I finally found the door—heavy wood, painted blue, with an ornate brass knocker—I was sweating and frustrated and ready to give up on Marrakech entirely.

The door opened to reveal a different world. A courtyard with a fountain, tiled walls in intricate geometric patterns, orange trees heavy with fruit. The air was cool and smelled like jasmine.

"Welcome," the owner said, a Moroccan woman in her fifties with kind eyes. "You must be Sophie. Your room is ready."

I'd booked the riad on a whim, needing to escape London and a job that was slowly killing my soul. Morocco seemed far enough away to matter.

My room was on the second floor, small but beautiful, with a window overlooking the courtyard. I showered, changed, and went up to the rooftop terrace to watch the sunset.

That's where I met him.

He was sitting at one of the small tables, a book in one hand, a glass of mint tea in the other. French, I guessed from the book cover. Mid-thirties, with dark hair and the kind of tan that suggested he spent a lot of time outdoors.

"Bonsoir," he said, looking up.

"Hi." I hesitated. "Is it okay if I sit here?"

"Of course. It's a shared space." He gestured to the other chair. "I'm Samir."

"Sophie."

We sat in comfortable silence for a while, watching the sun set over the medina. The call to prayer echoed from a nearby mosque, and the sky turned orange, then pink, then purple.

"First time in Marrakech?" he asked eventually.

"Yes. You?"

"I grew up here. But I live in Paris now. Just visiting family."

"Your English is perfect."

"French father, British mother. I had no choice but to be trilingual." He smiled. "What brings you to Morocco?"

"Running away, mostly."

"From what?"

"Everything. Work, London, the feeling that I'm living someone else's life."

He nodded. "I know that feeling. That's why I left Marrakech. And why I keep coming back. Sometimes you have to leave to remember why you loved something."

We talked until the stars came out. He told me about growing up between cultures, about his work as an architect in Paris, about the complicated relationship he had with Morocco—loving it and feeling suffocated by it in equal measure.

I told him about my corporate job, about the engagement I'd broken off six months ago, about the creeping sense that I was thirty-two and had somehow missed the turn where life was supposed to get interesting.

"So you came to Marrakech," he said.

"So I came to Marrakech."

"And? Is it interesting yet?"

I looked at him—really looked at him. Dark eyes, strong features, a mouth that looked like it smiled easily. "Getting there."

He held my gaze. "Good."

The owner brought up dinner—tagine, couscous, fresh bread. We ate on the rooftop, sharing dishes, drinking wine that was technically illegal but somehow available anyway.

"Tell me something," Samir said, pouring more wine. "What would you do if you could do anything? If money and expectations didn't matter."

"I'd write. Travel. Take photographs. Live in different cities and just... experience them."

"So why don't you?"

"Because that's not a real life. That's a fantasy."

"Who decided that?"

I didn't have an answer.

After dinner, we moved to the cushions at the edge of the rooftop, looking out over the medina. The city was alive with sounds—voices, music, the distant honking of mopeds.

"It's beautiful," I said.

"It is." But he was looking at me, not the view.

The air between us shifted. Became charged.

"Samir," I said quietly.

"Yes?"

"I should probably go to my room."

"Probably."

Neither of us moved.

Then he leaned in and kissed me.

It was soft at first, questioning. I answered by kissing him back, my hand sliding into his hair. He tasted like wine and mint, and when his hand found my waist, pulling me closer, I forgot every reason why this was a bad idea.

We broke apart, both breathing hard.

"Your room or mine?" he asked, his voice rough.

"Yours is closer."

His room was on the same floor as mine, larger, with a bed covered in colorful cushions and a window overlooking the medina. He closed the door behind us, and then we were on each other again, urgent and desperate.

Clothes came off between kisses. His hands explored my body like he was memorizing it, and I did the same, tracing the lines of his shoulders, his chest, the muscles of his back.

"You're sure?" he asked, even as his fingers slid between my legs, finding me wet and ready.

"Yes. Are you?"

"Very."

He laid me back on the bed, his body covering mine. His mouth moved down my neck, my collarbone, my breasts. When his tongue found my nipple, I arched off the bed with a gasp.

"Sensitive?" he murmured against my skin.

"Very."

He smiled and did it again, slower this time, his hand sliding lower. When his fingers found my clit, I moaned.

"You like that?"

"Yes. Don't stop."

He didn't. He worked me with his fingers, his mouth still on my breasts, until I was writhing beneath him, desperate for more.

"Please," I gasped. "I need you inside me."

He reached for a condom from the nightstand, rolled it on. Then he was pushing inside me, slow and deep, his eyes locked on mine.

"Okay?" he asked.

"Perfect. Move."

He set a rhythm that was exactly what I needed—deep, steady, building. I wrapped my legs around him, meeting each thrust, my nails digging into his shoulders.

"Touch yourself," he said, his voice rough. "I want to watch you come."

I slid my hand between us, finding my clit. The combination of his thrusts and my fingers was overwhelming.

"That's it," he encouraged. "Just like that."

I came with a cry, my body clenching around him. He followed seconds later, burying his face in my neck, my name on his lips.

Afterward, we lay tangled together, the sounds of the medina drifting through the open window.

"That was..." I started.

"Unexpected?" he finished.

"I was going to say incredible."

He smiled, pulling me closer. "That too."

I stayed in his room that night. We made love again in the early morning, slow and lazy, the call to prayer echoing through the medina as the sun rose.

"Stay another day," he said as we lay in the aftermath. "Let me show you Marrakech. The real Marrakech, not the tourist version."

"I have a flight tomorrow."

"Change it."

I should've said no. Should've stuck to my plan, kept things simple.

"Okay," I said. "One more day."

One day became three. He showed me hidden gardens, tiny restaurants in the souks, rooftops where locals gathered to watch the sunset. We spent our nights in his room, exploring each other with the kind of intensity that comes from knowing it's temporary.

On my last night, we sat on the rooftop where we'd met, drinking mint tea under the stars.

"Come to Paris," he said. "Visit me."

"Maybe."

"That means no."

"That means maybe." I took his hand. "This was perfect, Samir. Let's not ruin it by trying to make it something it's not."

"What if it could be something?"

"What if it's perfect exactly as it is?"

He was quiet for a moment, then nodded. "You're probably right."

"I usually am."

He laughed, and we spent our last night together the way we'd spent all the others—tangled in his bed, the sounds of Marrakech drifting through the window, holding onto something we both knew we'd have to let go.

I did go to Paris, six months later. We spent a weekend together, and it was good—different from Marrakech, but good. We still talk, still send messages when one of us is traveling.

But Marrakech remains ours—that rooftop, that riad, those nights when the medina felt like the only place in the world that mattered.

Because sometimes the best stories are the ones that don't need an ending. Sometimes a rooftop in Marrakech is exactly where you need to be, even if only for a few days. Sometimes a stranger becomes the person who reminds you that life can still surprise you, if you let it.`
};
